import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoney = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z",
			fill: "#fff",
			opacity: .655
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.5,
			y: 21.5,
			width: 29,
			height: 17,
			rx: 1.5,
			fill: "#d9daee",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19,
			y: 25,
			width: 22,
			height: 10,
			rx: 1,
			fill: "none",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 30,
			cy: 30,
			r: 3.5,
			fill: "#d9daee",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 22.5,
			y1: 30,
			x2: 23.5,
			y2: 30,
			fill: "none",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 36.5,
			y1: 30,
			x2: 37.5,
			y2: 30,
			fill: "none",
			stroke: "#7284fa",
			strokeLinecap: "round",
			strokeWidth: 1
		})
	]
});
export default SvgMoney;
